import { connect } from 'react-redux';

import {
  similarPackagesStartAction,
  clearSearchAction,
} from '../../../store/actions/similar-packages';

import SearchParams from './SearchParams';

const mapDispatchToProps = (dispatch) => ({
  onSubmit: () => dispatch(similarPackagesStartAction()),
  onClear: () => dispatch(clearSearchAction()),
});

export default connect(null, mapDispatchToProps)(SearchParams);
